'use client';
import { marketDataApi } from '@core/market-data-sdk';
import useSWR from 'swr';

import { IBaseChartProps } from '../base-chart/interface';
import { IWithFetchDataProps } from './interface';
import { createProfitSeries } from '../../create-series';

export const withFetchData =
  (Component: React.FC<IBaseChartProps>) =>
  ({ identifiers, ...props }: IWithFetchDataProps & IBaseChartProps) => {
    const key = identifiers ? identifiers.join(',') : null;
    let series = props.series || [];

    const { data, isLoading } = useSWR<any>([key, 'quotes-2'], async () => {
      if (!identifiers) return null;

      const quotes = await Promise.all(
        identifiers.map(async (identifier: string) =>
          marketDataApi.general.getQuotes({ identifier, safe: true })
        )
      );

      return quotes;
    });

    if (data) {
      series = createProfitSeries(data);
    }

    return <Component {...props} loading={isLoading} series={series} />;
  };
